import React from 'react'
import EarthWorkBanner from './EarthWorkBanner'
import EarthworkServices from './EarthworkServices'
import TestimonialSlider from '../../Common/TestimonialSlider/TestimonialSlider'
import ProjectStats from '../../Common/ProjectStats/ProjectStats'

function EarthWork() {
    return (
        <div>
            <EarthWorkBanner />
            <EarthworkServices/>
            <ProjectStats/>
            <TestimonialSlider/>
        </div>
    )
}

export default EarthWork
